import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./BreadcrumbDropdown.module.css";

interface BreadcrumbDropdownProps {
  trigger: React.ReactNode;
  items: { label: string; href: string }[];
}

export default function BreadcrumbDropdown({
  trigger,
  items,
}: BreadcrumbDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className={styles.dropdownWrapper} ref={dropdownRef}>
      <div onClick={() => setIsOpen(!isOpen)}>{trigger}</div>
      {isOpen && (
        <div className={styles.dropdownMenu}>
          {items.map((item, index) => (
            <div
              key={index}
              className={styles.dropdownItem}
              onClick={() => navigate(item.href)}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
